// Color constants
export const COLORS = {
  // Base colors
  white: "#FFFFFF",
  black: "#000000",

  // Primary colors
  primary: "#25233F",
  primaryHover: "#1a1a2e",

  // Background colors
  background: {
    main: "#F9FAFB",
    section: "#F2F4F7",
    sectionHeader: "#E9D7D9",
    iconCircle: "#F2F4F7",
  },

  // Border colors
  border: "rgba(208, 213, 221, 0.5)",

  // Text colors
  text: {
    primary: "#101828",
    secondary: "#475467",
    tertiary: "#374151",
    label: "#6B7280",
  },

  // Alert/Error colors
  error: "#F04438",
  errorHover: "rgba(240, 68, 56, 0.08)",

  // Badge/Stripe colors
  stripe: {
    primary: "#706E9A",
    secondary: "#9896C4",
  },

  // Status colors
  success: "#12B76A",
} as const;

// Spacing constants (in px)
export const SPACING = {
  xs: "4px",
  sm: "8px",
  md: "12px",
  lg: "16px",
  xl: "20px",
  xxl: "24px",
  xxxl: "32px",
  xxxxl: "56px",
} as const;

// Typography constants
export const TYPOGRAPHY = {
  button: {
    medium: {
      fontFamily: "Roboto",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: "0.4px",
      textTransform: "uppercase" as const,
    },
  },
  heading: {
    h4: {
      fontFamily: "Inter Bold",
      fontWeight: 700,
      fontSize: "24px",
      lineHeight: "32px",
    },
    h5: {
      fontWeight: 700,
      fontSize: "18px",
      lineHeight: "28px",
      color: COLORS.primary,
    },
  },
  body: {
    large: {
      fontWeight: 700,
      fontSize: "16px",
      lineHeight: "24px",
    },
    medium: {
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: 400,
    },
    small: {
      fontSize: "14px",
      fontWeight: 600,
    },
  },
  count: {
    large: {
      fontSize: "36px",
      fontWeight: 700,
      lineHeight: "44px",
      letterSpacing: "-0.02em",
    },
  },
} as const;

// Border radius constants
export const BORDER_RADIUS = {
  sm: "4px",
  md: "6px",
  lg: "8px",
  circle: "50%",
} as const;

// Shadow constants
export const SHADOWS = {
  xs: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
  card: "0px 1px 2px rgba(16, 24, 40, 0.05)",
} as const;

// Size constants
export const SIZES = {
  icon: {
    small: "20px",
    medium: "24px",
    container: "48px",
  },
  button: {
    icon: "36px",
  },
  stripe: {
    height: "32px",
  },
  badge: {
    height: "24px",
  },
} as const;

// Gradient/Pattern constants
export const PATTERNS = {
  diagonalStripe: (color1: string, color2: string) =>
    `repeating-linear-gradient(45deg, ${color1}, ${color1} 10px, ${color2} 10px, ${color2} 20px)`,
} as const;
